<template>
  <v-card class="overview-profile" flat>
    <h2 class="text-xs-left">Bilder-Upload</h2>
    <SetImages @upload="saveData" :images="images" @delete-picture="deletePicture" />

    <h2 class="text-xs-left">Video-Links</h2>
    <label>Video 1</label>
    <v-text-field
      placeholder="Titel zum Video"
      color="green"
      v-model="user_data.videolinks[0].title"
      solo
    ></v-text-field>
    <v-text-field
      placeholder="Link zum Video"
      color="green"
      v-model="user_data.videolinks[0].link"
      solo
    ></v-text-field>
    <label>Video 2</label>
    <v-text-field
      placeholder="Titel zum Video"
      color="green"
      v-model="user_data.videolinks[1].title"
      solo
    ></v-text-field>
    <v-text-field
      placeholder="Link zum Video"
      color="green"
      v-model="user_data.videolinks[1].link"
      solo
    ></v-text-field>

    <h2 class="text-xs-left">Nachrichten-Links</h2>
    <label>Artikel 1</label>
    <v-text-field
      placeholder="Titel zum Artikel"
      color="green"
      v-model="user_data.newslinks[0].title"
      solo
    ></v-text-field>
    <v-text-field
      placeholder="Link zum Artikel"
      color="green"
      v-model="user_data.newslinks[0].link"
      solo
    ></v-text-field>
    <label>Artikel 2</label>
    <v-text-field
      placeholder="Titel zum Artikel"
      color="green"
      v-model="user_data.newslinks[1].title"
      solo
    ></v-text-field>
    <v-text-field
      placeholder="Link zum Artikel"
      color="green"
      v-model="user_data.newslinks[1].link"
      solo
    ></v-text-field>
  </v-card>
</template>

<script>
import { mapState } from 'vuex';
import SetImages from '../SetImages';

export default {
  name: 'gallery-tab',

  components: {
    SetImages,
  },

  computed: {
    ...mapState(['user_data']),

    images() {
      return this.user_data.galleryImages;
    },
  },

  methods: {
    saveData() {
      this.$emit('save-data');
    },

    deletePicture(index) {
      this.user_data.galleryImages.splice(index, 1);
    },
  },
};
</script>

<style scoped></style>
